// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import Loader from '../../../../common/Loader';

type Props = {
  isAttractiveScoreLoading: boolean,
  children: Node,
  i18nPath: string,
  score: number
};

function AttractiveScoreDimensionWrapper({
  isAttractiveScoreLoading, children, i18nPath, score,
}: Props) {
  return (
    <div className="attractive-dimension">
      <div className="dimension-header">
        <div className="dimension-title">
          <Translate value={`${i18nPath}.title`} />
        </div>
        <Translate
          value="attractiveScore.scoreParenthesis"
          score={score}
        />
      </div>
      <div className="attractive-score-subtitle"><Translate value={`${i18nPath}.subtitle`} /></div>
      <div className="attractive-score-explanation"><Translate value={`${i18nPath}.explanation`} /></div>
      {
        isAttractiveScoreLoading
          ? <Loader isLoading />
          : children
      }
    </div>
  );
}

export default AttractiveScoreDimensionWrapper;
